module.exports = __webpack_public_path__ + "img/single-product-40.4687d93.webp";